export default {"src":"/_next/static/media/gg.ee71b59d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};